import { css } from "@emotion/css";
import { PropsWithChildren } from "react";

export function RenderError(props: PropsWithChildren) {
  if (!props.children) {
    return null;
  }

  return <pre className={styles.renderError}>{props.children}</pre>;
}

const styles = {
  renderError: css({
    color: "red",
    backgroundColor: "#00000011",
    padding: "var(--space-2)",
  }),
};
